import React from 'react'
import { Button } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import OptionalButtons from './OptionalButtons'

const TemplateButtons = ({ id, product }) => {

  return (
    <>
      <Link to={`/message/${product}/${id}`}>
        <Button
          primary
          className="buttonOne"
        >
          Open {
            `${product === 'page' ? 'Page' : product === 'popup' ? 'Popup' : 'Email'}`
          } Builder
        </Button>
      </Link>
      <OptionalButtons id={id} product={product} />
    </>
  )
}

export default TemplateButtons
